import React, { PureComponent } from 'react'
import Validator from 'validatorjs';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

class VehiculoUsadoForm extends PureComponent {

  state = {}

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules)
    };
  }

  get rules() {
    return {
      montoAdquisicion: ['required', 'decimal:6'],
      montoEnajenacion: ['required', 'decimal:6'],
      claveVehicular: ['required', 'string', 'min:1', 'max:7'],
      marca: ['required', 'string', 'min:1', 'max:50'],
      tipo: ['required', 'string', 'min:1', 'max:50'],
      modelo: ['required', 'string', 'regex:/^[0-9]{4}$/'],
      numeroMotor: ['string', 'min:1', 'max:17'],
      numeroSerie: ['string', 'min:1', 'max:17'],
      NIV: ['string', 'min:1', 'max:17'],
      valor: ['required', 'decimal:6']
    }
  }

  componentDidMount() {
    this.handleOnChange(this.props.data);
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value
    }

    const validator = this.validate(data);

    this.props.onChange({
      data,
      isValid: validator.passes()
    });
  }

  render() {
    const { data } = this.props;
    const rules = this.rules;

    return (
      <>
        <Row>
          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Monto Adquisición"
              name="montoAdquisicion"
              placeholder=""
              help=""
              rules={ rules.montoAdquisicion }
              value={ data.montoAdquisicion }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Monto Enajenación"
              name="montoEnajenacion"
              placeholder=""
              help=""
              rules={ rules.montoEnajenacion }
              value={ data.montoEnajenacion }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Clave Vehicular"
              name="claveVehicular"
              minLength="1"
              maxLength="7"
              rules={ rules.claveVehicular }
              value={ data.claveVehicular }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Marca"
              name="marca"
              minLength="1"
              maxLength="50"
              rules={ rules.marca }
              value={ data.marca }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Tipo Vehículo"
              name="tipo"
              minLength="1"
              maxLength="50"
              rules={ rules.tipo }
              value={ data.tipo }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Modelo"
              name="modelo"
              placeholder=""
              help=""
              rules={ rules.modelo }
              value={ data.modelo }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Número de Motor"
              name="numeroMotor"
              placeholder=""
              help=""
              minLength="1"
              maxLength="17"
              rules={ rules.numeroMotor }
              value={ data.numeroMotor }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Número de Serie"
              name="numeroSerie"
              minLength="1"
              maxLength="17"
              rules={ rules.numeroSerie }
              value={ data.numeroSerie }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="NIV"
              name="NIV"
              minLength="1"
              maxLength="17"
              rules={ rules.NIV }
              value={ data.NIV }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Valor"
              name="valor"
              rules={ rules.valor }
              value={ data.valor }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>
      </>
    )
  }
}

export default VehiculoUsadoForm;